// Rules given to the page as written, outside the build. The production build rewrites `:dir()` into a test of the
// page's language for older browsers: that answers for the interface, whose direction is the language's, but not
// for a piece of text laid out in its own direction. A browser without `:dir()` drops these rules and nothing else.
export const JARYAN_RUNTIME_RULES = [
  // A preview line in the chat list takes its direction from its own first letter, and the text inside it is
  // not counted: so in a right-to-left language a line with no sender before it, or with a Latin one, is laid
  // out from the left. Such a line is pushed to the row's right end by the free space before its first part,
  // and what is on it keeps its own order. A line with no free space, like one with a sender's name longer
  // than the row, stays as it is and is cut at its end.
  '.Chat[dir="rtl"] .last-message:dir(ltr) > :first-child { margin-left: auto; }',
];

export function applyJaryanRuntimeStyles() {
  const style = document.createElement('style');
  style.textContent = JARYAN_RUNTIME_RULES.join('\n');
  document.head.appendChild(style);
}

applyJaryanRuntimeStyles();
